import { createSelector } from 'reselect'

import { detectColors } from './utils'

const getGeneralClusterData = data => ({
  avgRevenue: data.revenuePerStoreCurrent,
  avgRevenueCompared: data.revenuePerStoreCompared,
  revenuePerM2Compared: data.revenuePerM2Compared,
  revenuePerM2Current: data.revenuePerM2Current,
  revenuePerStoreComparedL4L: data.revenuePerStoreComparedL4L,
  revenuePerStoreCurrentL4L: data.revenuePerStoreCurrentL4L,
  revenuePerStorePercent: data.revenuePerStorePercent,
  revenuePerStorePercentL4L: data.revenuePerStorePercentL4L,
  showLogoOnly: !!data.channel,
  storesCompared: data.storesCompared,
  storesCurrent: data.storesCurrent,
  storesCurrentL4L: data.storesCurrentL4L,
  totalRevenue: data.revenueCurrent,
  type: data.cluster || data.channel,
  ...detectColors(data.cluster || data.channel),
})

export const getCountries = createSelector(
  (state, props) => state.countries.list.find(country => country.countryID === props.countryID),
  country => ({
    ...country,
    clusters: country.clusters.map(getGeneralClusterData),
  }),
)

export const getCountriesFiltered = createSelector(
  (state, props) => state.countries.list.find(country => country.countryID === props.countryID),
  country => {
    const countryData = country ? country.filteredData || country : {}
    return {
      ...countryData,
      clusters: countryData.clusters.map(getGeneralClusterData),
    }
  },
)

export const getClusters = createSelector(
  state => state.stores.clusters.clusters,
  clusters => clusters.map(getGeneralClusterData),
)

export const getClusterFilter = createSelector(
  (state, props) => state.countries.list.find(c => c.countryID === props.countryID),
  country => country.filterByCluster,
)
